
import { UnitMeasureApiModel } from "@/core/models/api/unit-measure-api-model.model";
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const selectUnitMeasureId = (a: UnitMeasureApiModel): number => {
    if(!a.unitMeasureId){
        throw new Error("projectTypeId is required");
    }
    return a.unitMeasureId; 
}
// Entity setup
export interface UnitMeasureState extends EntityState<UnitMeasureApiModel> {
    errorMessage: string | null;
}

// Pure function adapter
export const unitMeasureAdapter: EntityAdapter<UnitMeasureApiModel> = createEntityAdapter<UnitMeasureApiModel>(
    {
        selectId: selectUnitMeasureId,
        sortComparer: false
    }
);

// Initial state
export const initialUnitMeasureState: UnitMeasureState = 
      unitMeasureAdapter.getInitialState({
          errorMessage: null
      });